import React, { useEffect, useState } from 'react';
import Helmet from '~/components/Helmet/Helmet';
import { useConfigMC, useTermsMC } from '~/store/Query/api';

import '~/sass/modules/_static.scss';

const Terms = () => {
  const { data } = useTermsMC();
  const { data: config } = useConfigMC();
  const [htmlMC, sethtmlMC] = useState('');

  let entrega = '2-3 días hábiles';
  if (config?.ok) {
    const data = config.body;

    if (data.diasEntrega && data.diasEntrega.activo) {
      const valor = data.diasEntrega.valor;
      let plural = '';
      if (valor === 1) {
        entrega = '1 día';
      } else {
        entrega = `${valor} días`;
        plural = 'es';
      }
      if (!data.diasEntrega.incluyeFinDeSemana) {
        entrega += ' hábil' + plural;
      }
    }
  }

  useEffect(() => {
    const hash = window.location.hash;
    if (hash && htmlMC) {
      const val = hash.substring(1);
      const yOffset = -85;
      let element;
      switch (val) {
        default:
          element = document.getElementById(val);
          break;
      }
      if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({
          top: y,
          behavior: 'smooth',
        });
      }
    }
  }, [htmlMC]);

  useEffect(() => {
    if (data && data.ok) {
      sethtmlMC(data.body.replace(/{entrega}/g, entrega));
    }
  }, [data]);

  return (
    <main>
      <Helmet title={`Términos y Condiciones | Tienda Claro ${process.env.NEXT_PUBLIC_COUNTRY}`}/>
      <section className="static--terms">
        <span dangerouslySetInnerHTML={{ __html: htmlMC }}/>
      </section>
    </main>
  );
};

export default Terms;
